import { IAnswerOption } from './day-block';
import { QuizOptionDTO } from './quiz-block';
import { ScoreDTO } from './score';
import { StudentDTO } from './student';
import { IStudentAssignmentDTO } from './student-assignment';
import { RetryDTO } from '@models/retry';

export interface IStudentAnswerDTO {
  id: number;
  studentId: string;
  quizType?: string;
  originalOptions?: IAnswerOption[];
  studentOptionsAnswer?: string;
  originalTrueOrFalse?: boolean | string;
  studentTrueOrFalseAnswer?: boolean | string;
  originalText?: string;
  studentTextAnswer?: string;
  isCorrect?: boolean | null;
  studentAssignmentId: number;
  dayBlockId: number;
  studentAssignment?: IStudentAssignmentDTO;
  selectedQuizOptions: Partial<QuizOptionDTO>[];
  score: ScoreDTO;
  student: StudentDTO;
  attempts: number;
  retries?: RetryDTO[];
}

export class StudentAnswerDTO implements IStudentAnswerDTO {
  id: number = 0;
  studentId: string = '';
  quizType?: string = '';
  originalOptions?: IAnswerOption[];
  studentOptionsAnswer?: string = '';
  originalTrueOrFalse?: boolean | null = null;
  studentTrueOrFalseAnswer?: boolean | null = null;
  originalText?: string = '';
  studentTextAnswer?: string = '';
  isCorrect?: boolean | null = null;
  studentAssignmentId: number = 0;
  studentAssignment?: IStudentAssignmentDTO;
  dayBlockId: number = 0;
  selectedQuizOptions: Partial<QuizOptionDTO>[] = [];
  score: ScoreDTO = null;
  student: StudentDTO = null;
  attempts: number = 0;
  retries?: RetryDTO[] = [];

  constructor(configOverride?: Partial<IStudentAnswerDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IStudentAnswerRequestDTO {
  studentId: string;
  quizType?: string;
  originalOptions?: IAnswerOption[];
  studentOptionsAnswer?: string;
  originalTrueOrFalse?: boolean | null;
  studentTrueOrFalseAnswer?: boolean | null;
  originalText?: string;
  studentTextAnswer?: string;
  isCorrect?: boolean | null;
  studentAssignmentId: number;
  dayBlockId: number;
}

export class StudentAnswerRequestDTO implements IStudentAnswerRequestDTO {
  studentId: string;
  quizType?: string;
  originalOptions?: IAnswerOption[];
  studentOptionsAnswer?: string;
  originalTrueOrFalse?: boolean | null;
  studentTrueOrFalseAnswer?: boolean | null;
  originalText?: string;
  studentTextAnswer?: string;
  isCorrect?: boolean | null;
  studentAssignmentId: number;
  dayBlockId: number;
  constructor(configOverride?: Partial<IStudentAnswerRequestDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
